import { TEAM_OPERATORS } from "./team";

/**
 * `/enums/` is called with several distinct query-param combinations across
 * the tech-ui app shell and the location-edit view (`?build=1&env=1`,
 * `?operator=1`, `?country=1&type=1&partner=1&operator=1`,
 * `?country=1&type=1&operator=1&locationFacilities=1`). One response returns the
 * union of the fields each caller reads, so a query variant the handler doesn't
 * recognize still gets every field populated rather than `undefined` (a bare
 * `undefined` reaching a caller-side `.reduce()`/`.map()` with no fallback throws).
 *
 * `operators` is the Team-access operator seed (FRO-400): the Users tab's Operator
 * filter and the create/edit-user and create-token dialogs all read this list, and
 * it is session-independent — every scope sees the same options.
 */
const ENUMS_RESPONSE = {
  env: "e2e",
  build: "0.0.0",
  buildTime: "2026-07-16T10:00:00.000Z",
  operators: TEAM_OPERATORS,
  countryList: [],
  locationType: [],
  partner: [],
  locationFacilities: [],
};

export { ENUMS_RESPONSE };
